export const POPOVER_WIDTH = 250;

export const ANIMATED_ICONS = [
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 10,
    position: { top: '0', left: '-10.37%' },
    animationDuration: '2.8s',
  },
  {
    icon: 'star',
    color: '#005ED9',
    size: 8,
    position: { bottom: '-12.5%', right: '-4.44%' },
    animationDuration: '2.2s',
  },
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 6,
    position: { bottom: '29.16%', right: '-8.89%' },
    animationDuration: '2.6s',
  },
].map((props, key) => ({ ...props, key }));
